const state = {
	pageTitle: '',
	pageHrefName:''
}

const getters = {
	pageTitle: state => {
		return state.pageTitle;
	},
	pageHrefName: state => {
		let pageHrefName= localStorage.getItem("SIP-pageHrefName");
		if(pageHrefName){
			state.pageHrefName=pageHrefName;
		}
		return state.pageHrefName;
	}
}

const actions = {
	pageTitleHandler(context, payload){
		context.commit('pageTitleHandler', payload);
	},
	pageHrefNameHandler(context, payload){
		context.commit('pageHrefNameHandler', payload);
	}
}

const mutations = {
	pageTitleHandler(state, pageTitle){
		state.pageTitle = pageTitle;
	},
	pageHrefNameHandler(state, pageHrefName){
		localStorage.setItem("SIP-pageHrefName",pageHrefName);
		state.pageHrefName = pageHrefName;
	}
}

export default {
	state,
	getters,
	actions,
	mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/page/index.js